"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HideOnEmbed = HideOnEmbed;
const jsx_runtime_1 = require("react/jsx-runtime");
const embed_context_provider_1 = require("./embed-context-provider");
function HideOnEmbed({ children, names }) {
    const embed = (0, embed_context_provider_1.useEmbed)();
    if (!embed.isEmbed) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    if (!names) {
        return null;
    }
    const targetEmbeds = [names].flat();
    const shouldHide = targetEmbeds.includes(embed.name);
    return shouldHide ? null : children;
}
